import {NgModule} from '@angular/core';
import {TransactionListPageModule} from './transaction-list-page/transaction-list-page.module';
import {ProductDeterminationPageModule} from '@app/test/product-determination-page/product-determination-page.module';
import {CtaValidationPageModule} from '@app/test/cta-validation-page/cta-validation-page.module';
import {ProductsPageModule} from '@app/test/products-page/products-page.module';

@NgModule({
  declarations: [],
  imports: [TransactionListPageModule,ProductDeterminationPageModule,CtaValidationPageModule,ProductsPageModule],
  exports: [TransactionListPageModule,ProductDeterminationPageModule,CtaValidationPageModule,ProductsPageModule],
})
export class TestModule {}
